<template>
  <b-card no-body>
    <b-card-header class="pb-0">
      <div class="float-left">
        <b-avatar
          class="float-left mb-1"
          :variant="`light-${color}`"
          size="45"
        >
          <feather-icon
            size="21"
            :icon="icon"
          />
        </b-avatar>
        <b-card-title class="float-left mt-1 ml-1 mr-5">{{ statisticTitle }}</b-card-title>
        <b-dropdown
          no-caret
          right
          text="Last 24 Hours"
          variant="transparent"
          class="chart-dropdown dropdown-item-list mt-1"
          toggle-class="p-50"
          size="sm"
        >
          <b-dropdown-item href="#">
            Last 7 Days
          </b-dropdown-item>
          <b-dropdown-item href="#">
            Last 30 Days
          </b-dropdown-item>
          <b-dropdown-item href="#">
            Last 3 Months
          </b-dropdown-item>
          <b-dropdown-item href="#">
            Last 6 Months
          </b-dropdown-item>
          <b-dropdown-item href="#">
            Last Year
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </b-card-header>

    <b-card-body class="pb-0">
      <!-- <b-avatar
        class="mb-1"
        :variant="`light-${color}`"
        size="45"
      >
        <feather-icon
          size="21"
          :icon="icon"
        />
      </b-avatar> -->
      <div class="truncate">
        <h2 class="mb-25 font-weight-bolder">
          {{ statistic }}
        </h2>
        <!-- <span>{{ statisticTitle }}</span> -->
      </div>
    </b-card-body>

    <vue-apex-charts
      type="area"
      height="100"
      width="100%"
      :options="chartOptionsComputed"
      :series="chartData"
    />

  </b-card>
</template>

<style lang="scss" scoped>
.dropdown-item-list {
  right: 10px;
  position: absolute;
}
</style>

<script>
import {
  BCard, BCardHeader, BCardTitle, BDropdown, BDropdownItem, BCardBody, BAvatar,
} from 'bootstrap-vue'
// import { BCard, BCardBody, BAvatar } from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import { $themeColors } from '@themeConfig'
import { areaChartOptions } from './chartOptions'

export default {
  components: {
    VueApexCharts,
    BCard,
    BCardHeader,
    BCardTitle,
    BDropdown,
    BDropdownItem,
    BCardBody,
    BAvatar,
  },
  props: {
    icon: {
      type: String,
      required: true,
    },
    statistic: {
      type: [Number, String],
      required: true,
    },
    statisticTitle: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: 'primary',
    },
    chartData: {
      type: Array,
      default: () => [],
    },
    chartOptions: {
      type: Object,
      default: null,
    },
  },
  computed: {
    chartOptionsComputed() {
      if (this.chartOptions === null) {
        const options = JSON.parse(JSON.stringify(areaChartOptions))
        options.theme.monochrome.color = $themeColors[this.color]
        return options
      }
      return this.chartOptions
    },
  },
}
</script>
